import type { PermissionsResponse } from '@/apis/permissions';
import type { PermissionFeature } from '@/utils/permissionFeatures';

export type { PermissionFeature } from '@/utils/permissionFeatures';
export type PermissionAction = 'create' | 'read' | 'update' | 'delete' | 'list';
export type ResolvedPermissionScope = 'all' | 'own' | 'none';

export const getScope = (
  permissions: PermissionsResponse | null,
  feature: PermissionFeature,
  action: PermissionAction
): ResolvedPermissionScope => {
  if (!permissions) {
    return 'none';
  }

  const featurePermissions = permissions.features[feature];
  if (!featurePermissions) {
    return 'none';
  }

  const scope = featurePermissions[action];
  if (scope === 'all' || scope === 'own') {
    return scope;
  }

  return 'none';
};

export const hasPermission = (
  permissions: PermissionsResponse | null,
  feature: PermissionFeature,
  action: PermissionAction
): boolean => {
  const scope = getScope(permissions, feature, action);
  return scope === 'all' || scope === 'own';
};
